/* GSM Reparatie Purmerend - accessoire productpagina (V1): aantal en totaalprijs */
(function () {
'use strict';
function formatMoney(cents, format) {
var f = format || (String.fromCharCode(8364) + '{{amount_with_comma_separator}}');
var m = /\{\{\s*(\w+)\s*\}\}/.exec(f);
function fmt(n, dec, thou, decSep) {
var fixed = (n / 100).toFixed(dec).split('.');
var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
return dec ? whole + decSep + fixed[1] : whole;
}
var value;
switch (m ? m[1] : 'amount_with_comma_separator') {
case 'amount': value = fmt(cents, 2, ',', '.'); break;
case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
default: value = fmt(cents, 2, '.', ',');
}
return f.replace(/\{\{\s*\w+\s*\}\}/, value);
}
function init(root) {
if (root.hasAttribute('data-grp-ta-ready')) return;
root.setAttribute('data-grp-ta-ready', '');
var dataEl = root.querySelector('[data-grp-json]');
if (!dataEl) return;
var data;
try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
var idInput = root.querySelector('[data-grp-id]');
var qtyInput = root.querySelector('[data-grp-qty-input]');
var val = root.querySelector('[data-grp-qty-val]');
var minus = root.querySelector('[data-grp-qty-minus]');
var plus = root.querySelector('[data-grp-qty-plus]');
var total = root.querySelector('[data-grp-total]');
var sum = root.querySelector('[data-grp-qty-sum]');
var qty = 1;
function variant() {
var id = idInput ? parseInt(idInput.value, 10) : 0;
for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
return data.variants[0];
}
function max(v) { return v && typeof v.qty === 'number' && v.qty > 0 ? v.qty : 99; }
function update() {
var v = variant();
if (!v) return;
var m = max(v);
if (qty > m) qty = m;
if (qty < 1) qty = 1;
if (val) val.textContent = qty;
if (qtyInput) qtyInput.value = qty;
if (total) total.textContent = formatMoney(v.price * qty, data.moneyFormat);
if (sum) sum.textContent = ' ' + String.fromCharCode(183) + ' ' + qty + 'x';
if (minus) minus.disabled = qty <= 1;
if (plus) plus.disabled = qty >= m || !v.available;
}
if (minus) minus.addEventListener('click', function () { qty -= 1; update(); });
if (plus) plus.addEventListener('click', function () { qty += 1; update(); });
root.addEventListener('click', function (e) {
if (e.target.closest && e.target.closest('[data-grp-value]')) setTimeout(update, 0);
});
update();
}
function initAll() { document.querySelectorAll('[data-grp-ta]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
else initAll();
document.addEventListener('shopify:section:load', initAll);
})();
